// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelect.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var OverflowText = require('share/components/controls/Izenda.OverflowText');
  var TreeView = require('share/components/controls/Izenda.TreeView');
  var classnames = require('classnames');
  const { get } = require('lodash/fp');
  var TreeItem = observer(
    React.createClass({
      propTypes: {
        item: React.PropTypes.object.isRequired,
        onCheckChange: React.PropTypes.func.isRequired,
        applyFormater: React.PropTypes.func
      },

      handleChange: function(event) {
        this.props.onCheckChange({
          value: event.target.value,
          checked: event.target.checked
        });
      },

      render: function() {
        var props = this.props;
        var item = props.item;
        var applyFormater = props.applyFormater;
        var classIcon = classnames('u_noMarginLeft', {
          'icon-triangle-down': !props.isCollapsed,
          'icon-triangle-right': props.isCollapsed
        });

        return (
          <span className="overflow-text" value={item.value}>
            {props.toggleIcon && <i className={classIcon} onClick={props.toggle} />}
            <label className="u_noPaddingTop checkbox-inline">
              <input type="checkbox" checked={item.checked} value={item.value} onChange={this.handleChange} />
              <OverflowText text={applyFormater(item.text)} tooltip={item.text} />
            </label>
          </span>
        );
      }
    })
  );

  var TreeSelect = React.createClass({
    propTypes: {
      className: React.PropTypes.string,
      data: React.PropTypes.array,
      onChange: React.PropTypes.func
    },
    renderNode: function(node, toggleIcon, toggle, isCollapsed) {
      var props = this.props;
      var onCheckChange = props.onChange;
      var applyFormater = props.applyFormater;

      return (
        <TreeItem
          onCheckChange={onCheckChange}
          applyFormater={applyFormater}
          item={node}
          toggleIcon={toggleIcon}
          toggle={toggle}
          isCollapsed={isCollapsed}
        />
      );
    },

    render: function() {
      var props = this.props;
      var treeData = props.data || [];

      return (
        <div className={'TreeSelect u_borderAll u_borderRadius u-bgWhite ' + (this.props.className || '')}>
          <TreeView
            className="u_noPaddingRight"
            treeViewItemClassName="u_noPaddingTop"
            nodes={treeData}
            renderNode={this.renderNode}
            getKey={get('key')}
            getChildNodes={get('nodes')}
            collapsed={false}
          />
        </div>
      );
    }
  });

  module.exports = TreeSelect;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.TreeSelect.jsx